export default __webpack_public_path__ + "static/media/logo-stiftung-berliner-mauer.f39998fc.svg";